import {convertToRoman} from 'app/helpers/convertToRoman';

export default function formatTeamNameWithLevel(name: string, level: number) {
  return level > 1 ? `${name} ${convertToRoman(level)}` : name;
}
